
const checkIfUngradedExists = (data: any[]) => {
    if (!data) {
        return
    }
    return data.filter(exam_component => {
        return ((exam_component.graded === false) && (exam_component.grade_viewed == false) && (exam_component.exam_component_base_title != 'Writing'));
    }).map((exam_component) => {
        return exam_component.id
    })
};

export default checkIfUngradedExists;